<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useAccountStore } from '../../store/account';
import Typography from '../../../../_01_atoms/components/Typography.vue';
import UpdateStripePaymentMethodButton from '../../components/Stripe/UpdateStripePaymentMethodButton.vue';
import { trans } from '../../../../_00_elements/translation';

const store = useAccountStore();

const { getBankName } = store;
const { paymentMethod } = storeToRefs(store);

const bankName = computed(() => getBankName(paymentMethod.value.bank_code));
</script>

<template>
  <div>
    <div class="payment-method__bank-account bank-account-card card">
      <Typography variant="body" class="card-content">
        <template v-if="bankName">
          {{ trans('gestion.pay.payment_method.bank_account.bank') }} <strong>{{ bankName }}</strong><br>
        </template>
        {{ trans('gestion.pay.payment_method.bank_account.iban') }} <strong>**** **** **** {{ paymentMethod.last4 }}</strong>
      </Typography>
    </div>
    <UpdateStripePaymentMethodButton />
  </div>
</template>
